import { ActiveSubscriptionDataRoute } from "routes/data-routes/billing-data/active-subscription";
import { ActiveCouponsDataRoute } from "routes/data-routes/billing-data/coupons/active-coupons";
import { CheckCouponsDataRoute } from "routes/data-routes/billing-data/coupons/check-coupons";
import { PricingOptionsDataRoute } from "routes/data-routes/billing-data/pricing-options";
import { PlansDataRoute } from "routes/data-routes/billing-data/plans";


export const DataRoutes = [
  ActiveCouponsDataRoute,
  ActiveSubscriptionDataRoute,
  CheckCouponsDataRoute,
  PlansDataRoute,
  PricingOptionsDataRoute
];
